export default __webpack_public_path__ + "static/media/femimed_korytarz_2.7bfa2f49.webp";